import styled from 'styled-components';
import {
  Segment as SegmentLayoutComponent,
  Loader as LoaderLayoutComponent,
  Text as TextLayoutComponent,
} from '@playbookux/playbook-web-core';

export const Card = styled(SegmentLayoutComponent)`
  &.ui.segment {
    margin-bottom: 25px;
    padding: 20px;
  }
`;

export const Loader = styled(LoaderLayoutComponent).attrs(() => ({
  inline: false,
}))``;

export const ContainerChart = styled.div``;
export const ErrorContainer = styled.div``;
export const ErrorText = styled(TextLayoutComponent)``;
